import React, { ReactNode } from 'react';
import { EventBus } from '@/shared/utils';
import { CatalogEvents } from '../events';
import {
  UserStatusType,
  UserStatusContext as GlobalUserStatusContext,
  CourseAccess,
  UserStatusContextValue,
  useUserStatus,
} from 'src/contexts/user-status-provider';

// Re-exporting from global context to maintain backward compatibility
export type { UserStatusType, CourseAccess, UserStatusContextValue };

// Transitional props for backward compatibility
interface UserStatusProviderProps {
  children: ReactNode;
  eventBus?: EventBus<CatalogEvents>;
}

/**
 * @deprecated Use the global UserStatusProvider from @/contexts/user-status-provider
 * This component is kept for backward compatibility only.
 */
export const UserStatusProvider: React.FC<UserStatusProviderProps> = ({ children }) => {
  // We're not using the eventBus parameter anymore since the real provider is at the app level
  return <>{children}</>;
};

// Re-export the context itself with alias
export const UserStatusContext = GlobalUserStatusContext;

/**
 * @deprecated Use the useUserStatus hook from @/contexts/user-status-provider
 * Hook is kept for backward compatibility.
 */
export { useUserStatus };
